import { Audit, User } from './types';
import type { ServicePlanId } from './servicePlans';

export const mockUsers: User[] = [
  {
    id: '1',
    email: 'admin@elevadvisor.com',
    name: 'Carlos Mendes',
    role: 'admin',
  },
  {
    id: '2',
    email: 'cliente@edificio.pt',
    name: 'Maria Santos',
    role: 'user',
  },
];

export const mockAudits: Audit[] = [
  {
    id: '1',
    clientId: '2',
    clientName: 'Maria Santos',
    buildingType: 'Residencial',
    numberOfElevators: 2,
    yearOfInstallation: 1998,
    lastInspectionDate: '2023-06-15',
    mainConcern: 'Ruídos estranhos durante a operação',
    planId: 'pro' as ServicePlanId,
    technicalScore: 72,
    status: 'completed',
    safety: {
      explanation: 'Os sistemas de segurança principais encontram-se operacionais, com alguns componentes a necessitar de atenção preventiva.',
      observations: [
        'Sistema de paragem de emergência funcional',
        'Cabos de tracção em bom estado',
        'Sensor de porta apresenta desgaste moderado',
        'Iluminação de emergência operacional',
      ],
    },
    compliance: {
      explanation: 'O equipamento cumpre a maioria dos requisitos legais em vigor, com algumas atualizações recomendadas.',
      observations: [
        'Certificação ASME A17.1 válida',
        'Última inspeção obrigatória dentro do prazo',
        'Sinalética a necessitar de atualização',
        'Documentação técnica completa',
      ],
    },
    futureRisk: {
      explanation: 'Considerando a idade do equipamento, prevê-se a necessidade de intervenções preventivas nos próximos 2 anos.',
      observations: [
        'Sistema de controlo a atingir fim de vida útil em ~3 anos',
        'Recomenda-se orçamentação para modernização do quadro elétrico',
        'Componentes de desgaste requerem stock de substituição',
      ],
    },
    reportPdfUrl: '/reports/audit-1.pdf',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2024-01-20T14:30:00Z',
  },
  {
    id: '2',
    clientId: '2',
    clientName: 'Maria Santos',
    buildingType: 'Comercial',
    numberOfElevators: 4,
    yearOfInstallation: 2010,
    lastInspectionDate: '2024-01-10',
    mainConcern: 'Avaliação para renovação de contrato de manutenção',
    planId: 'essential' as ServicePlanId,
    technicalScore: 45,
    status: 'in_analysis',
    safety: {
      explanation: 'Identificadas situações que requerem intervenção para garantir níveis de segurança adequados.',
      observations: [
        'Sistema de comunicação de emergência com falhas intermitentes',
        'Dois elevadores com sensores de sobrecarga descalibrados',
        'Desgaste acentuado em guias de cabine',
      ],
    },
    compliance: {
      explanation: 'Alguns requisitos regulamentares necessitam de atualização para conformidade total.',
      observations: [
        'Inspeção periódica pendente há 3 meses',
        'Atualização de software de controlo recomendada',
      ],
    },
    futureRisk: {
      explanation: 'Sem intervenção, prevê-se degradação acelerada do sistema.',
      observations: [
        'Risco de paragens não programadas elevado',
        'Custos de manutenção corretiva tendem a aumentar',
      ],
    },
    createdAt: '2024-02-01T09:00:00Z',
    updatedAt: '2024-02-01T09:00:00Z',
  },
  {
    id: '3',
    clientId: '3',
    clientName: 'João Ferreira',
    buildingType: 'Hospitalar',
    numberOfElevators: 6,
    yearOfInstallation: 2018,
    planId: 'premium' as ServicePlanId,
    technicalScore: 28,
    status: 'completed',
    safety: {
      explanation: 'Situação crítica identificada. Recomenda-se intervenção imediata.',
      observations: [
        'Falha no sistema de nivelamento',
        'Botão de emergência inoperacional em 2 cabines',
        'Sistema de ventilação de emergência com defeito',
        'Portas com tempo de fecho irregular',
      ],
    },
    compliance: {
      explanation: 'Não conformidades graves identificadas.',
      observations: [
        'Certificação expirada',
        'Múltiplas não conformidades em inspeção anterior não resolvidas',
        'Documentação incompleta',
      ],
    },
    futureRisk: {
      explanation: 'Sem correção imediata, risco operacional e legal elevado.',
      observations: [
        'Possível interdição por autoridades',
        'Responsabilidade civil em caso de acidente',
        'Necessidade de modernização urgente',
      ],
    },
    adminNotes: 'Cliente informado da gravidade. Aguarda proposta de intervenção.',
    reportPdfUrl: '/reports/audit-3.pdf',
    createdAt: '2024-01-28T11:00:00Z',
    updatedAt: '2024-02-05T16:00:00Z',
  },
];

export const buildingTypes = [
  'Residencial',
  'Comercial',
  'Industrial',
  'Hospitalar',
  'Hoteleiro',
  'Educacional',
  'Misto',
  'Outro',
];
